import React from 'react'
import './products-not-found.css'

export default (props) => (
  <div className='ProductsNotFound' {...props}>
    <h1>Sorry, no search items are found</h1>
  </div>
)
